import React from 'react';

const FilterBar = ({ filters, onFilterChange, instanceCount, totalCount, accounts }) => {
  const states = [
    { value: 'all', label: 'All States' },
    { value: 'running', label: 'Running' },
    { value: 'stopped', label: 'Stopped' },
    { value: 'pending', label: 'Pending' },
    { value: 'stopping', label: 'Stopping' }
  ];

  return (
    <div className="bg-white shadow-md rounded-lg p-4 space-y-4 w-full">
      <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4">
        {/* State filter */}
        <div className="w-full md:w-1/2">
          <select
            value={filters.state}
            onChange={(e) => onFilterChange('state', e.target.value)}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {states.map((state) => (
              <option key={state.value} value={state.value}>
                {state.label}
              </option>
            ))}
          </select>
        </div>

        {/* Account filter */}
        <div className="w-full md:w-1/2">
          <select
            value={filters.account}
            onChange={(e) => onFilterChange('account', e.target.value)}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="all">All Accounts</option>
            {accounts?.map((account) => (
              <option key={account.id} value={account.id}>
                {account.name || account.id}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Filter counts */}
      <div className="text-sm text-gray-600">
        Showing {instanceCount} of {totalCount} instances
        {filters.state !== 'all' || filters.account !== 'all' ? (
          <button
            onClick={() => {
              onFilterChange('state', 'all');
              onFilterChange('account', 'all');
            }}
            className="ml-2 text-blue-500 hover:text-blue-700 focus:outline-none"
          >
            Clear filters
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default FilterBar; 